<script setup lang="ts">
export interface EventCountdownProps {
  date?: null | number | string | Date;
}

const { t } = useI18n();
const props = defineProps<EventCountdownProps>();
const emit = defineEmits(["timeupdate", "finish"]);

const displayDays = ref<number | string>(0);
const displayHours = ref<number | string>(0);
const displayMinutes = ref<number | string>(0);
const displaySeconds = ref<number | string>(0);
let timer: any = null;
const second = 1000; // milliseconds
const minute = second * 60;
const hour = minute * 60;
const day = hour * 24;

const onTimeUpdate = () => emit("timeupdate");
const onFinishCountdown = () => emit("finish");

const showRemaining = () => {
  if (props.date === null || Number.isNaN(new Date(props.date as any).getDate()))
    return;

  timer = setInterval(() => {
    const now = new Date();
    const end = new Date(props.date as Date);
    const distance = end.getTime() - now.getTime();

    onTimeUpdate();

    if (distance < 0) {
      clearInterval(timer);
      onFinishCountdown();
      return;
    }

    const days = Math.floor(distance / day);
    const hours = Math.floor((distance % day) / hour);
    const minutes = Math.floor((distance % hour) / minute);
    const seconds = Math.floor((distance % minute) / second);
    displayDays.value = days < 10 ? `0${days}` : days;
    displayHours.value = hours < 10 ? `0${hours}` : hours;
    displayMinutes.value = minutes < 10 ? `0${minutes}` : minutes;
    displaySeconds.value = seconds < 10 ? `0${seconds}` : seconds;
  }, 100);
};

onMounted(() => showRemaining());
onBeforeUnmount(() => clearInterval(timer));
</script>

<template>
  <div class="BaseCountdown">
    <ul class="BaseCountdown__list">
      <li class="BaseCountdown__listOption">
        <span class="BaseCountdown__listTime text-main">
          {{ displayDays }}
        </span>
        <span class="text-caption-medium text-secondary">
          {{ t('labels.days', 0) }}
        </span>
      </li>
      <li class="BaseCountdown__verticalLine" role="separator" />
      <li class="BaseCountdown__listOption">
        <span class="BaseCountdown__listTime text-main">
          {{ displayHours }}
        </span>
        <span class="text-caption-medium text-secondary">
          {{ t('labels.hours', 0) }}
        </span>
      </li>
      <li class="BaseCountdown__verticalLine" role="separator" />
      <li class="BaseCountdown__listOption">
        <span class="BaseCountdown__listTime text-main">
          {{ displayMinutes }}
        </span>
        <span class="text-caption-medium text-secondary">
          {{ t('labels.minutes', 0) }}
        </span>
      </li>
      <li class="BaseCountdown__verticalLine" role="separator" />
      <li class="BaseCountdown__listOption">
        <span class="BaseCountdown__listTime text-main">
          {{ displaySeconds }}
        </span>
        <span class="text-caption-medium text-secondary">
          {{ t('labels.seconds', 0) }}
        </span>
      </li>
    </ul>
  </div>
</template>

<style lang="scss">
.BaseCountdown {
  //TODO: change style
    @apply w-full h-[85px] rounded-md;
    background: var(--base-countdown-bgColor);
}
.BaseCountdown__list {
    @apply flex w-full h-full items-center;
}

.BaseCountdown__listOption {
  @apply inline-block text-center min-w-[3rem] w-1/4;
}

.BaseCountdown__listTime {
  @apply text-2xl md:text-3xl font-bold max-w-[640px] block;
}

.BaseCountdown__verticalLine {
  @apply h-[41px] w-[1px];
  background-color: var(--base-footer-line-color);

}
</style>
